import Ship from './cruising-ship.svg'
import Point from './point.svg'
import Chevron from './chevron.svg'
import RegionPicker from './region-picker.svg'
import ArrowRight from './arrow-right.svg'
import ArrowWhite from './arrow-white.svg'
import Back from './back.svg'
import Play from './Play.svg'
import SelectedShip from './selected-ship.svg'
import SelectedPoint from './selected-point.svg'
import Close from './close.svg'
import Visit from './360-degree.svg'
import CloseChevron from './close-chevron.svg'
import LogoPonant from './logo.svg'
import Search from './search.svg'
import Cross from './cross.svg'
import Plus from './plus.svg'

const icons = {
  point: Point,
  ship: Ship,
  chevron: Chevron,
  plus: Plus,
  'region-picker': RegionPicker,
  'arrow-right': ArrowRight,
  'arrow-white': ArrowWhite,
  close: Close,
  'close-chevron': CloseChevron,
  closeCruise: require('./close-cruise.png'),
  'cruising-status': require('./cruising-status.png'),
  back: Back,
  play: Play,
  round: Visit,
  'selected-point': SelectedPoint,
  'selected-ship': SelectedShip,
  logo: LogoPonant,
  earth: require('./earth.png'),
  search: Search,
  cross: Cross,
  '01n': require('./01n@2x.png'),
  '02n': require('./02n@2x.png'),
  '03n': require('./03@2x.png'),
  '04n': require('./04@2x.png'),
  '09n': require('./09@2x.png'),
  '10n': require('./10n@2x.png'),
  '11n': require('./11@2x.png'),
  '13n': require('./13@2x.png'),
  '50n': require('./50@2x.png'),
  '01d': require('./01d@2x.png'),
  '02d': require('./02d@2x.png'),
  '03d': require('./03@2x.png'),
  '04d': require('./04@2x.png'),
  '09d': require('./09@2x.png'),
  '10d': require('./10d@2x.png'),
  '11d': require('./11@2x.png'),
  '13d': require('./13@2x.png'),
  '50d': require('./50@2x.png'),
}

export default icons
